<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 160 160"
    height="65px"
    width="65px"
    :style="'fill:' + color"
  >
    <rect
      class="cls-1"
      x="25"
      y="25"
      width="130"
      height="130"
      rx="30"
      style="fill:white;stroke:black;stroke-width:1"
    ></rect>
    <text
      v-if="seatNo"
      fill="#000000"
      font-size="40px"
      font-family="Roboto"
      :x="seatNo > 9 ? '80' : '100'"
      y="70"
    >{{ seatNo ? seatNo : "" }}</text>
  </svg>
</template>

<script>
export default {
  props: ["seatNo", "color", "pointer"],
  data() {
    return {};
  },
  methods: {
    clickSeat() {
      console.log("Emit Click Seat");
      this.$emit("clickSeat");
    }
  }
};
</script>
